<template lang="pug">
  ods-dropdown(
    :hide-on-click='false'
    icon='setting'
    @visible-change='handleVisibleChange')
    ods-dropdown-menu.popover-columns.desplegable(slot='dropdown')
      h3.titulosetting {{ $t('msg_generics.filter_table_menu') }}
      ods-dropdown-item(
        v-for='(column, index) in columns',
        :key='index')
        ods-checkbox(
          @input='handlerShowColumns(column)',
          v-model='column.show')
          | {{ column.text }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'b2b-table-menu-cierrescontables',
  props: [],
  data () {
    return {
      columns: [],
      column: {}
    }
  },
  computed: {
    ...mapGetters([
      'isAccountingCloseTableProjectNameShown',
      'isAccountingCloseTableBuyerNameShown',
      'isAccountingCloseTableNameShown',
      'isAccountingCloseTableCloseDateTimeShown',
      'isAccountingCloseTableStatusShown',
      'isAccountingCloseTableStartDateShown',
      'isAccountingCloseTableEndDateShown',
      'isAccountingCloseTableChildAccountingCloseNameShown',
      'optionsFilterService'
    ])
  },
  methods: {
    ...mapActions([
      'setAccountingCloseTableProjectNameShown',
      'setAccountingCloseTableBuyerNameShown',
      'setAccountingCloseTableNameShown',
      'setAccountingCloseTableCloseDateTimeShown',
      'setAccountingCloseTableStatusShown',
      'setAccountingCloseTableStartDateShown',
      'setAccountingCloseTableEndDateShown',
      'setAccountingCloseTableChildAccountingCloseNameShown'
    ]),

    handlerShowColumns (col) {
      console.log('handlerShowColumns en B2bTable: ', col)
      const column = col.value
      switch (column) {
        // case 'id':
        //   this.$store.dispatch('isShowIdFactura', !this.isShowIdFactura)
        //   break;
        case 'projectName':
          this.setAccountingCloseTableProjectNameShown(
            !this.isAccountingCloseTableProjectNameShown
          )
          break
        case 'buyerName':
          this.setAccountingCloseTableBuyerNameShown(
            !this.isAccountingCloseTableBuyerNameShown
          )
          break
        case 'name':
          this.setAccountingCloseTableNameShown(
            !this.isAccountingCloseTableNameShown
          )
          break
        case 'closeDateTime':
          this.setAccountingCloseTableCloseDateTimeShown(
            !this.isAccountingCloseTableCloseDateTimeShown
          )
          break
        case 'status':
          this.setAccountingCloseTableStatusShown(
            !this.isAccountingCloseTableStatusShown
          )
          break
        case 'startDate':
          this.setAccountingCloseTableStartDateShown(
            !this.isAccountingCloseTableStartDateShown
          )
          break
        case 'endDate':
          this.setAccountingCloseTableEndDateShown(
            !this.isAccountingCloseTableEndDateShown
          )
          break
        case 'childAccountingCloseName':
          this.setAccountingCloseTableChildAccountingCloseNameShown(
            !this.isAccountingCloseTableChildAccountingCloseNameShown
          )
          break
        default:
          break
      }
    },
    handleVisibleChange () {
      this.chargeFilters()
    },
    chargeFilters () {
      this.columns = [
      //   {
      //   text: 'ID', value: 'id', show: this.isShowIdFactura
      // },
        {
          text: this.$t('accounting_closes.entity_table.project'),
          value: 'projectName',
          show: this.isAccountingCloseTableProjectNameShown
        },
        {
          text: this.$t('accounting_closes.entity_table.buyer'),
          value: 'buyerName',
          show: this.isAccountingCloseTableBuyerNameShown
        },
        {
          text: this.$t('accounting_closes.entity_table.name'),
          value: 'name',
          show: this.isAccountingCloseTableNameShown
        },
        {
          text: this.$t('accounting_closes.entity_table.close_date_time'),
          value: 'closeDateTime',
          show: this.isAccountingCloseTableCloseDateTimeShown
        },
        {
          text: this.$t('accounting_closes.entity_table.status'),
          value: 'status',
          show: this.isAccountingCloseTableStatusShown
        },
        {
          text: this.$t('accounting_closes.entity_table.start_date'),
          value: 'startDate',
          show: this.isAccountingCloseTableStartDateShown
        },
        {
          text: this.$t('accounting_closes.entity_table.end_date'),
          value: 'endDate',
          show: this.isAccountingCloseTableEndDateShown
        },
        {
          text: this.$t('accounting_closes.entity_table.child_accounting_close_name'),
          value: 'childAccountingCloseName',
          show: this.isAccountingCloseTableChildAccountingCloseNameShown
        }
      ]
      // Si el usuario sólo tiene un servicio, quitamos el checkbox de servicios
      if (this.optionsFilterService.length < 2) {
        this.columns.splice(0, 1)
        this.setAccountingCloseTableProjectNameShown(false)
      } else {
        this.setAccountingCloseTableProjectNameShown(true)
      }
    }
  },

  created () {
    this.chargeFilters()
  }
}
</script>

<style lang="scss" scoped>
.desplegable {
    top: 180px !important
}
.titulosetting {
      padding: 10px;
}
</style>
